import {combineReducers} from "redux";
import renderReducer from "./RenderReducer";
import searchReducer from "./SearchReducer";
import wizardReducer from "./WizardReducer";
import ricercaAssistenteReducer from "./RicercaAssistenteReducer";
import fileReducer from "./FileReducer";
import annuncioReducer from "./AnnuncioReducer";

const rootReducer = combineReducers({
    renderReducer: renderReducer,
    searchReducer: searchReducer,
    wizardReducer: wizardReducer,
    ricercaAssistenteReducer: ricercaAssistenteReducer,
    fileReducer: fileReducer,
    annuncioReducer: annuncioReducer
})

export default rootReducer;
